// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Contenedor Principal ===== */
.PageNotFound_container__hqOh3 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 160px);
  text-align: center;
  padding: 40px 20px;
  background-color: #f7f7f7;
}

/* ===== Título Principal (Error 404) ===== */
.PageNotFound_title__56Qy0 {
  font-size: 6rem;
  font-weight: 800;
  color: var(--naranja);
  margin-bottom: 10px;
  line-height: 1;
}

/* ===== Subtítulo (Mensaje) ===== */
.PageNotFound_subtitle__a0iTw {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--textoNegro);
  margin-bottom: 20px;
}

/* ===== Texto Indicador ===== */
.PageNotFound_goHomeText__WVj1H {
  font-size: 1rem;
  color: #555;
  margin-bottom: 5px;
}

/* ===== Enlace/Botón de Inicio ===== */
.PageNotFound_homeLink__aKBws {
  display: inline-block; 
  background-color: var(--naranja); 
  color: var(--textoBlanco);
  padding: 12px 30px;
  border-radius: 5px;
  font-weight: 600;
  text-decoration: none;
  transition: background-color 0.3s ease;
}

.PageNotFound_homeLink__aKBws:hover {
  background-color: var(--azul); 
  color: var(--textoBlanco);
}

@media (max-width: 767px) {
  .PageNotFound_title__56Qy0 {
    font-size: 4rem;
  }
  .PageNotFound_subtitle__a0iTw {
    font-size: 1.2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PageNotFound.module.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,6CAA6C;AAC7C;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE,qBAAqB;EACrB,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* ===== Contenedor Principal ===== */\n.container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: calc(100vh - 160px);\n  text-align: center;\n  padding: 40px 20px;\n  background-color: #f7f7f7;\n}\n\n/* ===== Título Principal (Error 404) ===== */\n.title {\n  font-size: 6rem;\n  font-weight: 800;\n  color: var(--naranja);\n  margin-bottom: 10px;\n  line-height: 1;\n}\n\n/* ===== Subtítulo (Mensaje) ===== */\n.subtitle {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--textoNegro);\n  margin-bottom: 20px;\n}\n\n/* ===== Texto Indicador ===== */\n.goHomeText {\n  font-size: 1rem;\n  color: #555;\n  margin-bottom: 5px;\n}\n\n/* ===== Enlace/Botón de Inicio ===== */\n.homeLink {\n  display: inline-block; \n  background-color: var(--naranja); \n  color: var(--textoBlanco);\n  padding: 12px 30px;\n  border-radius: 5px;\n  font-weight: 600;\n  text-decoration: none;\n  transition: background-color 0.3s ease;\n}\n\n.homeLink:hover {\n  background-color: var(--azul); \n  color: var(--textoBlanco);\n}\n\n@media (max-width: 767px) {\n  .title {\n    font-size: 4rem;\n  }\n  .subtitle {\n    font-size: 1.2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PageNotFound_container__hqOh3`,
	"title": `PageNotFound_title__56Qy0`,
	"subtitle": `PageNotFound_subtitle__a0iTw`,
	"goHomeText": `PageNotFound_goHomeText__WVj1H`,
	"homeLink": `PageNotFound_homeLink__aKBws`
};
export default ___CSS_LOADER_EXPORT___;
